define('home/views/ChannelCoverView',[
    'backbone-marionette',

    'home/models/Session',

    'home/mixins/withChannelBanner',
    'home/templates/channelCover',
], function (
    Marionette,

    Session,

    withChannelBanner,
    channelCoverTemplate
) {
    'use strict';

    var ChannelCoverView = Marionette.ItemView.extend({
        template: channelCoverTemplate,
        templateHelpers: function () {
            return {
                shouldFetch: this.model.shouldFetch(),
            };
        },

        events: {
            'click [data-action=show-metadata]': 'showMetadata',
            'click [data-action=hide-metadata]': 'hideMetadata',
        },

        initialize: function () {
            this.session = Session.get();

            // Required if the session user is checked upon render, so that the
            // check(s) will occur properly after the session use is fetched
            this.listenTo(this.session, 'change:id', this.render);

            this.listenTo(this.model, 'changeRelated:primaryForum', this.render);
        },

        modelEvents: {
            'sync': 'render',
        },

        showMetadata: function () {
            this.trigger('showMetadata', true);
        },

        hideMetadata: function () {
            this.trigger('showMetadata', false);
        },
    });

    var proto = ChannelCoverView.prototype;
    withChannelBanner.call(proto);

    return ChannelCoverView;
});

